export default {
    card: {
        receptionNumber: "",
        cardNumber: "",
        cardPw: "",
        cardExMonth: "",
        cardExYear: "",
        cardNickName: "",
        cardUserName: "", 
        cardUserBirth: ""
   },
   property: {
        back: true,
        padding: 0
   }
}



// WEBPACK FOOTER //
// ./src/store/state.js